import { Link } from 'react-router-dom';

export default function Article2() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <Link to="/blog" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-900 mb-4 cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Back to Blog
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mt-2 leading-tight">Creating a Minimalist Setup Around a Wall-Mounted Screen</h1>
          <time className="text-sm text-gray-500 mt-4 block">May 12, 2024</time>
        </div>
      </header>

      {/* Article Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <article className="prose prose-lg max-w-none">
          {/* Featured Image */}
          <div className="w-full h-96 mb-10 rounded-lg overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/0b88e6c3b2a6ec3341f160c4d14b6887.jpg"
              alt="Minimalist living space with wall-mounted TV"
              title="Minimalist living space with wall-mounted TV"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <p className="text-lg leading-relaxed text-gray-800">
            Minimalist interiors focus on clarity, balance, and functionality. A wall-mounted TV supports this design approach by reducing visual clutter and allowing technology to blend into the room.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            A minimalist setup typically involves careful screen placement, concealed cabling, and restrained use of furniture. Keeping surrounding décor simple helps the TV feel integrated rather than dominant within the space.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Lighting also plays an important role. Soft, indirect lighting can improve comfort while maintaining a calm atmosphere. This approach works particularly well in living rooms and bedrooms designed for relaxation.
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            Examples of clean, minimalist TV installations can be found at: <a href="https://storage.googleapis.com/tv-wall-mounting-melbourne/tv-wall-mounting-melbourne.html" className="text-gray-900 underline hover:text-gray-700 cursor-pointer break-all">https://storage.googleapis.com/tv-wall-mounting-melbourne/tv-wall-mounting-melbourne.html</a>
          </p>

          <p className="text-lg leading-relaxed text-gray-800">
            For general information on Australian government services and household support resources, the <a href="https://www.servicesaustralia.gov.au/" target="_blank" rel="noopener noreferrer" className="text-gray-900 underline hover:text-gray-700 cursor-pointer">Services Australia</a> website provides helpful context.
          </p>

          {/* Embedded Reference */}
          <div className="my-10 border border-gray-200 rounded-lg overflow-hidden">
            <iframe 
              src="https://www.google.com/maps/d/u/0/embed?mid=1f5EIslSmdqdtYTrv8TGpg4IgjKxwgYA&ehbc=2E312F&noprof=1"
              width="640"
              height="480"
              className="w-full h-96"
              title="Embedded map reference"
            ></iframe>
          </div>
        </article>

        {/* Navigation */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <Link 
            to="/blog"
            className="inline-flex items-center text-sm font-medium text-gray-900 hover:text-gray-700 cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Back to all articles
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-gray-200 mt-20">
        <div className="max-w-3xl mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-gray-600">
            <p>&copy; 2024 Wall Setup &amp; Home Installations. All rights reserved.</p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="mt-4 md:mt-0 hover:text-gray-900 cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
